import exponent from "./exponent.js";

export default function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/precisionRound.js
// module id = we+8
// module chunks = 0